const aboutheader=()=>{
    return(
        <>
            <div className="container-fluid">
                <div className="container aboutheader">
                    
                </div>
            </div>
        </>
    )
}
export default aboutheader